/**
 * Base configuration for TraceKit
 * All forks extend this config
 */

import { TraceKitConfig } from '../packages/core/src/types/config';
import { getApiBaseUrl, getEnvironment } from '../packages/core/src/utils/env';

export const baseConfig: TraceKitConfig = {
  api: {
    baseUrl: getApiBaseUrl(),
    timeout: 120000,
    retries: 3,
  },
  
  features: {
    rag: true,
    reports: true,
    entities: true,
    sources: true,
    jobs: true,
    webhooks: false,
    cache: false,
    admin: false,
  },
  
  branding: {
    appName: 'TraceKit',
    logo: '/logo.svg',
    favicon: '/favicon.ico',
    primaryColor: '#3B82F6',
    secondaryColor: '#10B981',
    companyName: 'Alpyne AI',
  },
  
  deployment: {
    environment: getEnvironment(),
    domain: 'localhost:3000',
    enableAnalytics: false,
  },
  
  plugins: [],
  
  customization: {
    searchSampleQueries: [
      'Show me all critical alerts',
      'What compliance deadlines are upcoming?',
      'List recent incidents',
      'Show me documents from last month',
      'What inspections are pending?',
      'Summarize current issues',
    ],
    entityTypes: [
      'alert',
      'unified_alert',
      'document',
      'document_registry',
      'compliance',
      'incident',
      'inspection',
      'equipment',
      'maintenance_log',
    ],
  },
};


